// extracted by mini-css-extract-plugin
module.exports = {"stepper":"Stepper_stepper__3C_KO","minus":"Stepper_minus__2W06T","plus":"Stepper_plus___OJD2"};